// extracted by mini-css-extract-plugin
export default {"scatterPlot":"ScatterPlot_scatterPlot__GcXWS"};